// ./Main/index.jsx
import React from "react";
import { Link } from "react-router-dom";
import collaboramate_image from "../image/collaboramate_icon.png";

const Index = () => {
  return (
    <div>
      <Link
        to="https://www.notion.so/collaboramate/CollaboraMate-90933f328cfd4c569c0fbe19f4bdf89c?pvs=4"
        target="_blank"
      >
        <img
          src={collaboramate_image}
          alt="collaboramate_icon"
          style={{ width: "100px", height: "auto" }}
        />
      </Link>
      <p>CollaboraMate 회원 탈퇴를 위한 페이지</p>
      <Link to="https://github.com/Minkun00" target="_blank">
        <p>Dev.Minkun</p>
      </Link>
      <Link to="/withdraw">회원탈퇴하기</Link>
    </div>
  );
};
export default Index;
